import { Link } from "react-router-dom";
import { isCrewStreakUnlocked, isStreakAtRisk, crewDaysInactive } from "@/lib/mockData";
import { Flame, AlertTriangle } from "lucide-react";

const CrewCard = ({ crew, index = 0 }) => {
  const streaked = isCrewStreakUnlocked(crew);
  const atRisk = isStreakAtRisk(crew);
  return (
    <Link
      to={`/crews/${crew.id}`}
      className={`block brutal-card p-4 fade-up ${atRisk ? "bg-[#FFFBEB]" : ""}`}
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`crew-card-${crew.id}`}
    >
      <div className="flex items-center gap-4">
        <div className="flex -space-x-3">
          {crew.members.slice(0, 4).map((m, i) => (
            <img
              key={m.id}
              src={m.avatar}
              alt={m.name}
              className="w-11 h-11 rounded-full brutal-border object-cover bg-white"
              style={{ zIndex: 10 - i }}
            />
          ))}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <h3 className="font-heading font-bold text-lg truncate">{crew.name}</h3>
            <span
              className="font-mono font-bold text-xs brutal-border bg-[#C8E6C9] rounded-full px-2 py-0.5"
              data-testid={`crew-compatibility-${crew.id}`}
            >
              {(crew.compatibility * 100).toFixed(0)}%
            </span>
          </div>
          <p className="text-xs text-[#555555] mt-0.5 truncate">
            {crew.members.length} members • last: {crew.last_activity}
          </p>
          <div className="mt-2 flex flex-wrap items-center gap-1.5">
            {crew.streak > 0 && (
              <span
                className={`inline-flex items-center gap-1 brutal-border rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ${streaked ? "bg-[#FF6A2C] text-white" : "bg-white"}`}
                data-testid={`crew-streak-${crew.id}`}
              >
                <Flame className="w-3 h-3" strokeWidth={2.5} />
                {crew.streak} streak
              </span>
            )}
            {atRisk && (
              <span
                className="inline-flex items-center gap-1 brutal-border bg-[#FFCC00] rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide"
                data-testid={`crew-at-risk-${crew.id}`}
              >
                <AlertTriangle className="w-3 h-3" strokeWidth={2.5} />
                {crewDaysInactive(crew)}d — streak at risk
              </span>
            )}
            {streaked && !atRisk && (
              <span className="text-[10px] font-bold text-[#FF6A2C] uppercase tracking-wide">Deal unlocked</span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default CrewCard;
